import { render, staticRenderFns } from "./AgentMessageInput.vue?vue&type=template&id=21c9b3db&scoped=true&"
import script from "./AgentMessageInput.vue?vue&type=script&lang=js&"
export * from "./AgentMessageInput.vue?vue&type=script&lang=js&"
import style0 from "./AgentMessageInput.vue?vue&type=style&index=0&id=21c9b3db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c9b3db",
  null
  
)

export default component.exports